var main = {
    jsToggles: function() {
        var linkToggle = document.querySelectorAll('.js-toggle');

        for(i = 0; i < linkToggle.length; i++) {
        linkToggle[i].addEventListener('click', function(event) {
        
        event.preventDefault();
        
        var container = document.getElementById(this.dataset.container);
        
        if (!container.classList.contains('active')) {
            this.classList.add('is-open');
            container.classList.add('active');
            container.style.height = 'auto';
        
            var height = container.clientHeight + 'px';
        
            container.style.height = '0px';
        
            var parentContainer = container.closest('.sub-parent')
        
        
            setTimeout(function () {
            container.style.height = height;
                if (parentContainer != undefined && parentContainer.clientHeight > 0) {
                setTimeout( function() {
                    parentContainer.style.height = 'auto';
                    var parentHeight = parentContainer.clientHeight + 'px';
            
                    parentContainer.style.height = '0px';
        
                    parentContainer.style.height = parentHeight;
                }, 100)
                }
            }, 0);
            
        } else {
            this.classList.remove('is-open');
            
            container.style.height = '0px';
        
            if (container.classList.contains('no-trans')) {
            container.classList.remove('active');
            } else {
            container.addEventListener('transitionend', function () {
                container.classList.remove('active');
            }, {
                once: true
            });
            }
            
            setTimeout(function () {
            var parentContainer = container.closest('.sub-parent')
            var innerSub = container.closest('.inner-sub')
        
            if (innerSub != null) {
                parentContainer.style.height = innerSub.clientHeight + 'px';
            }
            }, 100);
        }
        
        });
        
        }
    }
}

main.jsToggles()





// Clean Read More Function - Simple and Effective
document.addEventListener('DOMContentLoaded', function() {
  const productDescriptions = document.querySelectorAll('.product__description');
  
  productDescriptions.forEach(function(description) {
    // Check schema setting - skip if disabled
    if (description.dataset.enableReadmore === 'false') return;
    
    const fullHTML = description.innerHTML.trim();
    
    // Get text length to check if we need read more
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = fullHTML;
    const fullText = tempDiv.textContent || tempDiv.innerText || '';
    
    if (fullText.length > 210) {
      // Create the truncated version
      const truncatedHTML = truncateHTMLPreservingStructure(fullHTML, 210);
      
      // Create the wrapper div that will contain everything
      const wrapper = document.createElement('div');
      wrapper.className = 'description-content';
      
      // Create the button
      const readMoreBtn = document.createElement('button');
      readMoreBtn.className = 'read-more-btn';
      readMoreBtn.textContent = 'Read more';
      readMoreBtn.setAttribute('aria-expanded', 'false');
      
      // Set up the collapsed state
      wrapper.innerHTML = truncatedHTML;
      wrapper.appendChild(readMoreBtn);
      
      // Replace the original content
      description.innerHTML = '';
      description.appendChild(wrapper);
      
      // Add click handler
      readMoreBtn.addEventListener('click', function() {
        const isExpanded = readMoreBtn.getAttribute('aria-expanded') === 'true';
        
        if (isExpanded) {
          // Collapse
          wrapper.innerHTML = truncatedHTML;
          wrapper.appendChild(readMoreBtn);
          readMoreBtn.textContent = 'Read more';
          readMoreBtn.setAttribute('aria-expanded', 'false');
        } else {
          // Expand
          wrapper.innerHTML = fullHTML;
          wrapper.appendChild(readMoreBtn);
          readMoreBtn.textContent = 'Read less';
          readMoreBtn.setAttribute('aria-expanded', 'true');
        }
      });
    }
  });
});



function truncateHTMLPreservingStructure(html, maxChars) {
  const template = document.createElement('template');
  template.innerHTML = html;
  const container = template.content.cloneNode(true);
  
  // Create a wrapper to hold our result
  const wrapper = document.createElement('div');
  
  let charCount = 0;
  let truncated = false;
  
  function processNode(node, parent) {
    if (truncated) return;
    
    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.textContent;
      const remaining = maxChars - charCount;
      
      if (text.length <= remaining) {
        parent.appendChild(document.createTextNode(text));
        charCount += text.length;
      } else {
        let truncText = text.substring(0, remaining);
        const lastSpace = truncText.lastIndexOf(' ');
        if (lastSpace > remaining * 0.7) {
          truncText = truncText.substring(0, lastSpace);
        }
        parent.appendChild(document.createTextNode(truncText + '...'));
        truncated = true;
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      const tagName = node.tagName.toLowerCase();
      const className = node.className || '';
      const isSpecial = ['svg', 'img', 'i', 'br'].includes(tagName) || 
                       className.includes('icon') || 
                       className.includes('check');
      
      if (isSpecial) {
        parent.appendChild(node.cloneNode(true));
      } else {
        const clone = document.createElement(node.tagName);
        // Copy attributes
        Array.from(node.attributes).forEach(attr => {
          clone.setAttribute(attr.name, attr.value);
        });
        
        Array.from(node.childNodes).forEach(child => {
          processNode(child, clone);
        });
        
        if (clone.hasChildNodes()) {
          parent.appendChild(clone);
        }
      }
    }
  }
  
  Array.from(container.childNodes).forEach(node => {
    processNode(node, wrapper);
  });
  
  return wrapper.innerHTML;
}








// Close all accordions on page load
document.addEventListener('DOMContentLoaded', function() {
  // Find all details elements within accordion containers
  const accordionDetails = document.querySelectorAll('.product__accordion details');
  
  accordionDetails.forEach(function(details) {
    // Remove the 'open' attribute to close the accordion
    details.removeAttribute('open');
    
    // Update aria-expanded on the summary element
    const summary = details.querySelector('summary');
    if (summary) {
      summary.setAttribute('aria-expanded', 'false');
    }
  });
});


// feature typeface
document.addEventListener('DOMContentLoaded', function() {
  // Just add new selectors to this array
  const headingTargets = [
    '.rich-text__block-heading-template--18443661934804__rich_text_Nip6aD',
    '.collection__title h2',
    '.template-collection h2',
    '.template-product h2',
    '.template-index h2'
    // Add more as needed...
  ];
  
  // Apply heading-lead class to all targets
  headingTargets.forEach(selector => {
    document.querySelectorAll(selector).forEach(el => {
      el.classList.add('heading-lead');
    });
  });
});




// landing-page wrapping shadow
(function() {
  // Check if this is a landing page (has 'lp-' in any body class)
  const isLandingPage = Array.from(document.body.classList).some(className => 
    className.includes('lp-')
  );
  
  if (!isLandingPage) {
    return;
  }

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wrapSections);
  } else {
    wrapSections();
  }

  function wrapSections() {
    const main = document.querySelector('#MainContent');
    if (!main) return;

    // Get all direct children sections/divs with shopify-section class
    const allSections = Array.from(main.children).filter(child => 
      child.classList.contains('shopify-section') || 
      child.id.includes('shopify-section')
    );

    // Skip the first section
    const sectionsToWrap = allSections.slice(1);
    
    if (sectionsToWrap.length === 0) return;

    // Create the wrapper div
    const wrapper = document.createElement('div');
    wrapper.className = 'boxed-in-shadow';

    // Insert wrapper after the first section
    const firstSection = allSections[0];
    firstSection.parentNode.insertBefore(wrapper, firstSection.nextSibling);

    // Move all sections (except first) into the wrapper
    sectionsToWrap.forEach(section => {
      wrapper.appendChild(section);
    });

    // Add the styles
    addStyles();
  }

  function addStyles() {
    // Check if styles already exist
    if (document.getElementById('boxed-in-shadow-styles')) return;

    const style = document.createElement('style');
    style.id = 'boxed-in-shadow-styles';
    style.textContent = `
      .boxed-in-shadow {
        max-width: 1400px;
        margin: -20px auto;
        position: relative;
        background: #ffffff;
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 
                    0 2px 4px -1px rgba(0, 0, 0, 0.06);
        border-radius: 8px;
        overflow: hidden;
      }

      /* Adjust on mobile for less shadow/padding */
      @media screen and (max-width: 749px) {
        .boxed-in-shadow {
          margin: 0 10px;
          box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.08);
        }
      }
    `;
    document.head.appendChild(style);
  }
})();






// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', function() {
  const bikeSwitcher = document.querySelector('.bike-rack-switcher');
  const colorVariant = document.querySelector('#custom-unified-color');
  
  if (bikeSwitcher && colorVariant) {
    // Create wrapper div
    const wrapper = document.createElement('div');
    wrapper.style.cssText = 'display: flex; gap: 20px; align-items: center; margin-bottom: 0;';
    
    // Style the components
    bikeSwitcher.style.cssText = 'flex: 1;';
    colorVariant.style.cssText = 'margin-bottom: 0;';
    
    // Insert wrapper before bikeSwitcher
    bikeSwitcher.parentNode.insertBefore(wrapper, bikeSwitcher);
    
    // Move both elements into wrapper
    wrapper.appendChild(bikeSwitcher);
    wrapper.appendChild(colorVariant);
  }
});








